import React from 'react';
import logo from '../../../assets/images/brandlogo.png';
import './PublishersHeader.css';

export default function PublishersHeader() {

  return (
    <>
      <header className='publishermainHeader'>
        <div className='publishermainheaderContent'>
          <div className='container'>
            <nav className='publishermainheaderNav publishermainheadernavExpand flex-wrap'>
              <a href="/" className='publishermainheaderLeft me-auto'>
                <a href="https://www.authormeet.net/" >
                  <div className='publishermainheaderBrand d-flex align-items-start'>
                    <img src={logo} className='publishermainheaderBrandimage img-fluid' />
                    <div className='publishermainheaderbrandTitles'>
                      <h6> AuthorMeet </h6>
                      <p> Powered by: Bookworm Central </p>
                    </div>
                  </div>
                </a>
              </a>

            </nav>
          </div>
        </div>
      </header>
    </>
  )
}
